import { render } from "./InvoiceDetails.vue?vue&type=template&id=3a5a332a"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__